import React from 'react'

const NoteIcon = ({color = '#333945', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={19}
      viewBox="0 0 15 19"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M3.75 15.25h7.5v-1.5h-7.5v1.5Zm0-4h7.5v-1.5h-7.5v1.5ZM1.808 19c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 0 1 0 17.192V1.808C0 1.303.175.875.525.525.875.175 1.303 0 1.808 0H9.75L15 5.25v11.942c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H1.808ZM9 6V1.5H1.808a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v15.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h11.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V6H9Z"
      />
    </svg>
  )
}

export default NoteIcon
